<template>
  <div class="bdg-list-view">
    <table v-if="itemGroups">
      <template v-for="(items, groupKey) in itemGroups">
        <tr
          :class="{ 'first-in-group': index === 0 }"
          :key="`row_${groupKey}_${index}`"
          v-for="(item, index) in items"
        >
          <td class="grouping-cell" :rowspan="items.length" v-if="index === 0">
            <component
              :is="getGroupingCellComponentParams(groupKey).component"
              v-bind.sync="getGroupingCellComponentParams(groupKey).props"
            />
          </td>
          <td class="w-full">
            <component :is="itemComponent" v-bind.sync="item" />
          </td>
        </tr>
      </template>
    </table>
    <template v-else>
      <component
        :is="itemComponent"
        v-bind.sync="item"
        :key="`item_${index}`"
        v-for="(item, index) in items"
      />
    </template>
  </div>
</template>

<script>
import {
  DatetimeGroupByOptions,
  TableRowGroupTypes
} from "../../constants/enums";
import DayGroupingCell from "../table-view/special-cells/grouping-cells/DayGroupingCell";

export default {
  name: "BdgListView",
  props: {
    items: {
      type: Array,
      required: true
    },
    itemComponent: {
      type: Object,
      required: true
    },
    areItemsGrouped: Boolean,
    itemsGroupingParams: Object
  },
  computed: {
    itemGroups() {
      if (this.areItemsGrouped && this.itemsGroupingParams) {
        if (
          this.itemsGroupingParams.groupType &&
          this.itemsGroupingParams.groupType === TableRowGroupTypes.DATETIME
        ) {
          if (
            this.itemsGroupingParams.groupBy &&
            this.itemsGroupingParams.groupBy === DatetimeGroupByOptions.DAY &&
            this.itemsGroupingParams.groupByProperty
          ) {
            const groupByProp = this.itemsGroupingParams.groupByProperty;
            return this.items.reduce((acc, row) => {
              const day = this.$moment(row[groupByProp]).format("YYYY-MM-DD");
              if (!acc[day]) {
                acc[day] = [];
              }
              acc[day].push(row);

              return acc;
            }, {});
          }
        }
      }
      return null;
    }
  },
  methods: {
    getGroupingCellComponentParams(data) {
      if (this.itemGroups) {
        if (
          this.itemsGroupingParams.groupType &&
          this.itemsGroupingParams.groupType === TableRowGroupTypes.DATETIME
        ) {
          if (
            this.itemsGroupingParams.groupBy &&
            this.itemsGroupingParams.groupBy === DatetimeGroupByOptions.DAY
          ) {
            return {
              component: DayGroupingCell,
              props: { date: this.$moment(data).toDate() }
            };
          }
        }
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/assets";

.bdg-list-view {
  table {
    tr {
      &:not(:first-child) {
        .grouping-cell {
          @apply border-t border-white;
        }
      }

      &:nth-child(odd) {
        @apply bg-white;
      }

      &:nth-child(even) {
        @apply bg-lightgray-lightest;
      }

      .grouping-cell {
        @apply w-px border-r border-white p-3 bg-lightgray whitespace-no-wrap;
      }
    }
  }
}
</style>
